// src/LoginPage.js
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from './firebase';
import { Button, TextField, Container, Typography, Box, Link, Alert, Grid } from '@mui/material';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError('Falha ao fazer login. Verifique seu e-mail e senha.');
    }
  };

  const handlePasswordReset = () => {
    setError('');
    setMessage('');
    if (!email) {
      setError('Por favor, insira seu e-mail para recuperar a senha.');
      return;
    }
    sendPasswordResetEmail(auth, email)
      .then(() => {
        setMessage('E-mail de recuperação de senha enviado com sucesso!');
      })
      .catch((err) => {
        setError('Falha ao enviar e-mail de recuperação.');
      });
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {/* LOGOTIPO DA EMPRESA */}
        <img 
            src="/logo.png" 
            alt="Logo MBigucci" 
            style={{ maxWidth: '250px', marginBottom: '20px' }} 
        />

        <Typography component="h1" variant="h5">
          Gestão de Parceiros.  
        </Typography>
        <Box component="form" onSubmit={handleLogin} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Endereço de E-mail"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Senha"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Entrar
          </Button>
          
          {error && <Alert severity="error" sx={{ mt: 2, width: '100%' }}>{error}</Alert>}
          {message && <Alert severity="success" sx={{ mt: 2, width: '100%' }}>{message}</Alert>}

          <Grid container justifyContent="space-between">
            <Grid item>
              <Link component="button" type="button" variant="body2" onClick={handlePasswordReset}>
                Esqueceu sua senha?
              </Link>
            </Grid>
            <Grid item>
              <Link component={RouterLink} to="/solicitar-cadastro" variant="body2">
                {"Não tem uma conta? Solicite"}
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
}

export default LoginPage;